class BackToTop {
    constructor(buttonSelector, textSelector) {
        this.button = document.querySelector(buttonSelector);
        this.textElement = document.querySelector(textSelector);
        this.toggleHeight = window.outerHeight * 2;
        
        this.init();
    }
    
    init() {
        window.addEventListener("scroll", () => this.onScroll());
        this.button.addEventListener("click", (event) => this.scrollToTop(event));
        this.watchChatWidget();
    }
    
    onScroll() {
        const active = window.scrollY > this.toggleHeight;
        if (active === this.button.classList.contains("active")) {
            return;
        }
        this.button.classList.toggle("active", active);
        this.raiseChatLauncher(); // only when the button shows or hides, not on every scroll event
    }

    // the chat launcher stands above Back to top (both sit bottom right): while the button shows, the Desk widget's
    // launcher (and its chat window) take the widget's own raised position, .c-chat-bot-margin, inside its open shadow root
    raiseChatLauncher() {
        const host = document.getElementById("cool-chat-host");
        const root = host && host.shadowRoot;
        if (!root) {
            return;
        }
        const raised = this.button.classList.contains("active");
        root.querySelectorAll(".c-chat-bot, .c-modal-portal").forEach((el) => {
            el.classList.toggle("c-chat-bot-margin", raised);
        });
    }

    // the widget mounts on its own time: once its shadow root is there, its launcher is raised as it appears too
    watchChatWidget() {
        if (!window.MutationObserver) {
            return;
        }
        const watchShadowRoot = () => {
            const host = document.getElementById("cool-chat-host");
            if (!host || !host.shadowRoot) {
                return false;
            }
            new MutationObserver(() => this.raiseChatLauncher()).observe(host.shadowRoot, { childList: true, subtree: true });
            this.raiseChatLauncher();
            return true;
        };
        if (!watchShadowRoot()) {
            const widgetWatch = new MutationObserver(() => {
                if (watchShadowRoot()) {
                    widgetWatch.disconnect();
                }
            });
            widgetWatch.observe(document.documentElement, { childList: true, subtree: true });
        }
    }
    
    scrollToTop(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
    
    updateText(text) {
        if (this.textElement) {
            this.textElement.textContent = text;
        }
    }
}